import { datadogLogs } from '@datadog/browser-logs'
import { Component, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from 'ui/src/components/Text/Text'
import { sprinkles } from 'ui/src/theme/sprinkles.css'

const errorLogger = datadogLogs.createLogger('ErrorBoundary')

export class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  constructor(props: { children: ReactNode }) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: unknown, errorInfo: unknown) {
    if (error instanceof Error) {
      errorLogger.error('React render error', { errorInfo }, error)
    }
  }

  render() {
    if (this.state.hasError) {
      return <RenderErrorMessage />
    }

    return this.props.children
  }
}

// Separate component to allow hook API for localizing error message
function RenderErrorMessage() {
  const { t } = useTranslation()
  return (
    <Text className={sprinkles({ padding: 'md' })} style={{ border: 'solid 1px red' }}>
      {t('RENDER_ERROR_MESSAGE')}
    </Text>
  )
}
